export default __webpack_public_path__ + "static/media/logo.3027ce07.png";